import { checkPathExists } from "./lib/checkPathExists.js";
const checkHasProjectFile = async (args) => {
  const filePath = args.helpers.joinPathFromRoot(args.filename);
  return checkPathExists(filePath);
};
export {
  checkHasProjectFile
};
//# sourceMappingURL=checkHasProjectFile.js.map
